module.exports = __webpack_public_path__ + "static/media/5DPO23.e6ee0163.jpg";